<template>
  <div>
    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
    </div>
    <b-card>
      <!-- form -->
      <b-form @submit.prevent="">
        <b-row>
          <!-- bio -->

          <b-col cols="3">
            <b-form-group :label="$t('Reports')" label-for="vi-Reports-id">
              <v-select v-model="report_type" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="allReports.map((i)=>({id:i.id,name:$t(i.name)}))" :reduce="d => d.id" />

            </b-form-group>
          </b-col>






          <b-col cols="3">

            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 mr-1"
              @click="addReport(report_type)">
              <feather-icon icon="PlusSquareIcon" size="14" class="" />


              {{$t('Add')}}
            </b-button>
          </b-col>
        </b-row>

      </b-form>

      <table class="table table-striped ">
        <th>{{$t('Report')}}</th>
        <th>{{$t('settings/delete')}}</th>

        <tr v-for="report in reports" :key="report.type">

          <td>


            <div class="text-center">

              <b-badge variant="info">{{ $t(report.name) }}</b-badge>

            </div>
          </td>
          <td>

            <b-button variant="primary" class="rounded-circle  p-1 mr-2" type="submit"
              @click="openSetting(report.name)">
              <!-- <feather-icon
            icon="ClipboardIcon"
            size="10"
            :class="'text-primary'"
            style="color:white"
          /> -->
              <feather-icon icon="SettingsIcon" size="14" class="" />

            </b-button>



            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="rounded-circle  p-1"
              type="submit" @click="showDeleteAlert=true,currentseleted=report.name">

              <feather-icon icon="TrashIcon" size="14" class="" />



            </b-button>
           
            <b-modal id="modal-danger" ok-variant="danger" ok-title="Accept" modal-class="modal-danger" centered
              title="Delete Settings" v-model="showDeleteAlert" @ok="deleteSettings()"
              @cancel="confirmDelete=false">
              <b-card-text>
                {{$t('Delete Settings countinue?')}}
              </b-card-text>

            </b-modal>

          </td>
        </tr>

      </table>
      <hr />

      <h4>{{$t('General Settings for all')}}</h4>
      <b-form @submit.prevent="">
        <b-row>
          <!-- bio -->



          <b-col cols="6">
            <b-form-group :label="$t('emails')" label-for="vi-devices-id">
              <!-- <v-select  multiple :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{ name: $t('all'), id: 'all' }, ...emails]"
                :reduce="d => d.id"
               
                
                /> -->

              <b-form-textarea id="textarea-default" v-model="request.emails"
                data="example1@gmail.com,example2@gmsil.com" rows="3">

              </b-form-textarea>
            </b-form-group>
          </b-col>



          <b-col md="4">
            <b-form-group>
              <h5>{{$t('Pick Time')}}</h5>
              <flat-pickr v-model="request.schedule_at" class="form-control"
                :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', }" />
            </b-form-group>
          </b-col>
          <b-col>
            <br />
            <b-button variant="primary" class=" p-1 mr-2" type="submit" @click="saveGeneralSettings()">

              <feather-icon icon="SaveIcon" size="14" class="" />
              {{$t('save')}}
            </b-button>
          </b-col>

        </b-row>

      </b-form>
    </b-card>



    <!-- modal start  -->
    <b-modal v-model="show" title="Settings " title-tag="div" size="lg">
      <b-container>
        <div v-if="current_report == 'gardenPlan'">
          <GardenReport report_type="setting" />
        </div>


        <div v-if="current_report == 'supportDevices'">
          <SupportDevices report_type="setting" />
        </div>
        <div v-if="current_report == 'sweep'">
          <SweepReport report_type="setting" />
        </div>
        <div v-if="current_report == 'absence'">
          <AbsenceReport report_type="setting" />
        </div>
         
        <div v-if="current_report == 'trip'">
          <TripReport report_type="setting" />

        </div>
        <div v-if="current_report == 'status'">
          <StatusReport  report_type="setting"  />
        </div>
        <div v-if="current_report == 'geofence'">
          <GeofenceReport  report_type="setting"  />
        </div>


       
      </b-container>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <b-card-text class="mb-0">

          </b-card-text>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="secondary" size="sm" @click="show = false">
            {{$t('Close')}}
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- modal end -->








  </div>


</template>

<script>

import SweepReport from '@/views/reports/sweep/SweepReport.vue'
import GardenReport from '@/views/reports/garden/GardenReport.vue'
import AbsenceReport from '@/views/reports/absence/AbsenceReport.vue'
import TripReport from '@/views/reports/trip/TripReport.vue'
import StatusReport from '@/views/reports/Status/StatusReport.vue'
import GeofenceReport from '@/views/reports/Geofence/GeofenceReport.vue'

import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia, BContainer, BModal, BBadge, BFormTextarea
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, computed } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import Cleave from 'vue-cleave-component'

import Logic from './logic'

//import settingForm from '@/views/modules/account-setting/dialy-reports/form'

import SupportDevices from '@/views/reports/support-devices/SupportDevices.vue'

import settingForm from './form'
import { all } from 'q'
import axios from '@/libs/axios'
import { re } from 'semver'
import useHelpers from '@/views/modules/useHelpers'
export default {
  name: 'DailyReportSetings',
  components: {
    BRow,
    BCard,
    BFormCheckboxGroup,
    BTable,
    BPagination,
    BCol,
    BFormRadioGroup,
    BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput,
    flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    Cleave,
    BLink,
    BMedia,
    ToggleCollapse,
    BContainer,
    BModal,

    BBadge,
    BFormTextarea,
    AbsenceReport,
    GardenReport,
    TripReport,
    StatusReport,
    SupportDevices,
    SweepReport,
    GeofenceReport
  },
  directives: { Ripple, },
  data() {
    return {

      timePicker: null,

      settings: {


      }
    }

  },
  setup(props, { root }) {
    const loading=ref(false);
    let allReportData = null;
    const confirmDelete = ref(false)
    const showDeleteAlert = ref(false)
    const currentseleted=ref("")


  // const setSelectedReportToDeletet=(reportName)=>{
  //   showDeleteAlert.value=true;

  // }

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }



    const { emails, reports, schedule_at, allReports } = settingForm()
    const { request } = Logic()


    const report_type = ref(0)
    const show = ref(false);
    const current_report = ref("");
    const openSetting = (name) => {
      show.value = true;
      current_report.value = name;
    }
    const saveGeneralSettings = () => {
     loading.value=true;
      let postdata = {
        schedule_at: "",
        emails: [],
      };
      postdata.schedule_at = request.value.schedule_at;
      postdata.emails = request.value.emails.replace(/\n|\r/g, "").split(",")



      return new Promise((resolve, reject) => {
        axios.post(`user/setReportNotifications`, postdata)
          .then(res => {
            toaster('updated successfuly', 'success', 'success')
            loading.value=false;

          })
          .catch(reason => { 
            loading.value=false;
            toaster('update faild', 'Error', 'error')
          })
      })
    }
    const deleteSettings = () => {
    let  name =currentseleted.value;
         loading.value=true;
      return new Promise(() => {

        axios.delete(`user/setReportNotifications/reports`, { data: { type: name } })
          .then(res => {
            reports.value = reports.value.filter((r) => r.name != name)
            toaster('deleted successfuly', 'success', 'success')
            show.value = false;
            loading.value=false;
          })
          .catch(reason => {
            loading.value=false;
            const error_message = reason.response.data.errors.type[0] !== undefined ? reason.response.data.errors.type[0] : 'Error!'
            toaster(error_message, 'danger', 'Error')
          })
      })



    }
    const isExist = (reportName) => {
      const out = reports.value.find(report => {
        if (report.name == reportName) {

          return true;
        }


      })


      return out;

    }
    const addReport = (data) => {


      const newReport = allReports.value.find(report => report.id == report_type.value)

      if (!isExist(newReport.name)) {
        reports.value.push(newReport)

      }




    }




    request.value.emails = emails
    request.value.schedule_at = schedule_at;

    return {
      emails,
      reports,
      schedule_at,
      request,
      allReports,
      show,
      current_report,
      openSetting,
      addReport,
      report_type,
      isExist,
      deleteSettings,
      saveGeneralSettings,
      toaster,
      showDeleteAlert,
      confirmDelete,
      currentseleted,
      loading

    }
  }
}
</script>